import BaseEntity from '../../BaseEntity';

export default class TripCategory extends BaseEntity {
    public name: string;
    public visible: boolean;
    public group?: string;

    constructor(json: any) {
        super(json);

        this.name = json.name;
        this.visible = json.visible;
        this.group = json.group === '' ? undefined : json.group;
    }

    public toString(): string {
        return this.name;
    }
}
